<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="sixteen wide column">
            <Breadcrumb>
              <a class="section" v-go-back="'contracts'">Contratos</a>
              <i class="right chevron icon divider"></i>
              <router-link
                class="section"
                :to="`/contracts/${$route.params.contract_id}`"
              >
                {{ $route.params.contract_id }}
              </router-link>
              <i class="right chevron icon divider"></i>
              <div class="active section">
                <div class="neutral">Parcelas</div>
              </div>
            </Breadcrumb>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <div class="ui padded grid">
        <div class="row">
          <div class="sixteen wide column">
            <Grid
              ref="grid"
              resource="invoices"
              @refresh="loadData()"
              @page="n => loadData(n)"
            />
          </div>
        </div>
      </div>
    </template>
  </PageLayout>
</template>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';
import Grid from './widgets/grid';

export default {
  name: 'services',
  components: { Grid, Breadcrumb, PageLayout },

  data() {
    return {
      searchForm: {
        description: null,
        cod: null
      },
      query: {}
    };
  },

  mounted() {
    this.loadData();
  },

  // computed: {
  //   enableBoleto() {
  //     return (
  //       this.$store.state.settings.settings.payment_boleto_gateway_provider !=
  //       null
  //     );
  //   }
  // },

  methods: {
    async loadData() {
      try {
        this.$refs.grid.toggleLoading();
        const contractResponse = await Api.contracts.fetch(
          this.$route.params.contract_id
        );
        const contract = contractResponse.data.contract;

        const invoicesQuery = {
          q: {
            contract_id_eq: this.$route.params.contract_id,
            s: ['number asc']
          }
        };

        const invoicesReponse = await Api.invoices.search(invoicesQuery);
        const invoices = invoicesReponse.data.invoices;

        this.$refs.grid.setData(invoices, contract);
      } catch (e) {
        this.$toast.show('Erro ao carregar dados', 'error');
        throw e;
      } finally {
        this.$refs.grid.toggleLoading();
      }
    }
  }
};
</script>
